document.addEventListener('DOMContentLoaded', () => {
    initSearchBackButton();
});

function initSearchBackButton() {
    let timer = setInterval(() => {
        const searchContainer = document.querySelector('#boost-sd__instant-search-container');
        if (searchContainer) {
            clearInterval(timer);
            const closeBtns = searchContainer.querySelectorAll('.boost-sd__button-text-x');
            closeBtns.forEach(btn => {
                btn.innerHTML = 'BACK';
            });
        }
    }, 500);
    setTimeout(() => {
        clearInterval(timer);
    }, 10000);
}